{
  "redirect": {
    "head": {
      "tag": "LA SOLUZIONE DEC ENERGY",
      "title": "<h2>Scopri i vantaggi di adottare il nostro modello</h2>"
    },
    "left": {
      "title": "<h3>Sblocca il pieno potenziale del tuo capitale e accresci il tuo portafoglio di asset</h3>",
      "cta": "Per produttori indipendenti"
    },
    "right": {
      "title": "<h3>Accelera la tua transizione  energetica mantenendo la proprietà dei tuoi impianti</h3>",
      "cta": "Per utilities"
    }
  },
  "numeric-example": {
    "titleText": {
      "tag": "CASO DI ESEMPIO",
      "title": "<h2>Esempio di applicazione del modello DEC Energy</h2>",
      "description": "Scorri le pagine seguenti per visionare un esempio numerico dei vantaggi ottenuti da un produttore adottando il modello DEC Energy su un impianto del suo portafoglio."
    },
    "title": {
      "title": "<h3>Applicando il modello DEC Energy</h3>",
      "description": "<green>Moltiplica</green> il tuo capitale per costruire più assets mentre <green>fai derisking</green> dei primi 10 anni del tuo investimento"
    },
    "plant-details": {
      "disclaimer": "Quanto simulato non si sostanzia in assoluto modo in un preventivo da parte di DEC.\n *con sistema di tracking. produzione verificata con PVGIS.\n **100% merchant basato sulle curve Aurora",
      "rental-title": "Informazioni affitto",
      "plant-title": "Informazioni impianto",
      "plant-left": [
        "Peak Power",
        "Produzione specifica",
        "Investimento totale",
        "Investimento in equity",
        "Project financing",
        "Tasso di interesse",
        "Durata del debito",
        "Prezzo medio vendita energia",
        "Costi di manutenzione"
      ],
      "plant-right": [
        "4'989 kWp",
        "1'762 kWh/kWp",
        "€ 5'177'228",
        "20.2% (€ 1'045'800)",
        "79.8% (€ 4'131'428)",
        "4.60%",
        "20 anni",
        "71.94 €/MWh",
        "11.52 €/MWh"
      ],
      "rental-left": [
        "Durata dell'affitto",
        "% di asset affittato",
        "fee per gestione dell'asset"
      ],
      "rental-right": ["10 anni", "95%", "21.56 €/MWh"]
    },
    "keep": {
      "title": "Mantieni l'asset",
      "elements": [
        "Ricavi all' anno 0 (pagamento anticipato)",
        "Ricavi anni 1-10 ",
        "Costi OPEX & finanziari anni 1-10",
        "Totale dopo 10 anni",
        "",
        "IRR Equitity dopo 10 anni",
        "ROI Equity dopo 10 anni",
        "",
        "IRR Equitity dopo 35 anni",
        "ROI Equity dopo 35 anni"
      ]
    },
    "dec": {
      "title": "Affitta con DEC",
      "elements": [
        "Ricavi all' anno 0 (pagamento anticipato)",
        "Ricavi anni 1-10 (incl. commissioni) ",
        "Costi OPEX & finanziari anni 1-10",
        "Totale dopo 10 anni",
        "",
        "IRR Equitity dopo 10 anni",
        "ROI Equity dopo 10 anni",
        "",
        "IRR Equitity dopo 35 anni",
        "ROI Equity dopo 35 anni"
      ]
    },
    "YearTable": {
      "title": {
        "title": "<h3>I risultati in dettaglio</h3>",
        "description": "I numeri di anno in anno applicando il modello DEC energy. (dati in '000)"
      },
      "entries": [
        "",
        "Ricavi",
        "Costi OPEX",
        "Costi finanziari",
        "Cash flow netto dell'asset",
        "Distribuzione",
        "Netto dopo distribuzione"
      ]
    },

    "gain-recap": [
      "pagamento anticipato",
      "di equity sbloccata",
      "leva sul capitale proprio"
    ]
  },
  "calendly": {
    "tag": "SCOPRI TUTTI I VANTAGGI",
    "title": "<h2>Sblocca subito il tuo capitale affittando i tuoi impianti fotovoltaici</h2>",
    "description": "<b>Prenota un incontro con i nostri esperti</b> per ricevere un’analisi personalizzata dei vantaggi adottando DEC Energy."
  }
}
